<template>
  <div class="proposal-list" v-loading="isLoading">
    <div class="proposal-list__controls">
      <div class="proposal-list__controls__row">
        <r-search-input
          :filter-text="filterText"
          @change="e => filterChange(e)"
        />
      </div>
      <div class="proposal-list__controls__row">
        <r-text type="caption" style="margin-bottom:4px">
          {{ $t("proposal.status-filter") }}
        </r-text>
        <el-select v-model="statusFilter" size="mini" class="r-select">
          <el-option
            v-for="item in statusList"
            :key="item"
            :label="$t(`proposal.${item}`)"
            :value="item"
          />
        </el-select>
      </div>
    </div>
    <scrollbar :scrolling-x="false">
      <ul class="proposal-list__wrapper">
        <proposal-list-item
          v-for="(proposal, i) in filteredList"
          :key="proposal.id + i"
          :item="proposal"
        />
        <r-text
          v-if="!filteredList.length"
          type="caption"
          style="padding:0 40px;"
          class="empty-list"
        >
          {{
            filterText
              ? $t("proposal.list-notfound")
              : $t("proposal.list-empty")
          }}
        </r-text>
      </ul>
    </scrollbar>
  </div>
</template>

<script>
import scrollbar from "@/components/scrollbar/scrollbar";
import proposalListItem from "./proposal-list-item";

const statusList = ["all", "await", "accepted", "rejected"];

export default {
  props: {
    proposalList: { type: Array, default: () => [] },
    isLoading: { type: Boolean, default: false }
  },
  components: { scrollbar, proposalListItem },
  data() {
    return {
      filterText: "",
      statusFilter: "all",
      statusList
    };
  },
  computed: {
    filteredList() {
      const filteredByStatus = this.proposalList.filter(e => {
        switch (this.statusFilter) {
          case "all":
            return true;
          case "await":
            return !e.accepted && !e.rejected;
          case "accepted":
            return e.accepted;
          case "rejected":
            return e.rejected;
        }
      });

      return filteredByStatus
        .filter(
          n =>
            n.name.toLowerCase().indexOf(this.filterText.toLowerCase().trim()) >
            -1
        )
        .sort((a, b) => {
          if (a.created_at > b.created_at) return -1;
          if (a.created_at < b.created_at) return 1;
          return 0;
        });
    }
  },
  methods: {
    filterChange(e) {
      this.filterText = e;
    }
  }
};
</script>

<style lang="scss">
.proposal-list {
  height: 100%;
  box-sizing: border-box;
  padding: 16px 0 0;
  position: relative;
  overflow: hidden;
  &__controls {
    padding: 0 16px 8px 16px;
    position: relative;
    overflow: hidden;
    &__row {
      position: relative;
      margin-bottom: 12px;
      &:last-child {
        margin-bottom: 0;
      }
      .r-text.caption-2 {
        white-space: nowrap;
      }
    }
    .r-input {
      input {
        padding-left: 32px;
      }
    }
  }
  &__wrapper {
    text-align: center;
    .empty-list {
      height: 20vh;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .ritm-scrollbar {
    height: calc(100% - 104px);
  }
  .r-input__filter-icons {
    position: absolute;
    top: 4px;
    left: 12px;
    height: calc(100% - 8px);
    width: 12px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
  }
}
</style>

<i18n>
{
  "ru": {
    "proposal": {
      "status-filter": "Фильтр по статусу:",
      "all": "Все",
      "await": "В ожидании",
      "accepted": "Принятые",
      "rejected": "Отклоненные",
      "list-notfound": "По вашему запросу ничего не найдены",
      "list-empty": "Список заявок пуст"
    }
  },
  "en": {
    "proposal": {
      "status-filter": "Filter by status:",
      "all": "All",
      "await": "Awaiting",
      "accepted": "Accepted",
      "rejected": "Rejected",
      "list-notfound": "No users found by your request",
      "list-empty": "Proposal list empty"
    }
  }
}
</i18n>
